import { render, staticRenderFns } from "./CurrencyPicker.vue?vue&type=template&id=5a099e3f&scoped=true&"
import script from "./CurrencyPicker.vue?vue&type=script&lang=js&"
export * from "./CurrencyPicker.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyPicker.vue?vue&type=style&index=0&id=5a099e3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a099e3f",
  null
  
)

export default component.exports